import { z } from 'zod';

export const baseObjectSchema = z.object({
  id: z.string(),
  createdDate: z.string().optional(),
  lastUpdate: z.string().optional(),
  createUserId: z.string().optional(),
  updateUserId: z.string().optional(),
  isActive: z.boolean().optional(),
  isFromManager: z.boolean().optional(),
  boid: z.string().optional(),
  exportedDate: z.string().optional(),
  deleted: z.boolean().optional(),
  rowVersion: z.string().optional(),
});

export const baseSchema = z.object({
  id: z.string(),
  code: z.string().optional(),
  name: z.string().optional(),
  description: z.string().optional(),
});
